module.exports = __webpack_public_path__ + "static/media/1973.fe16d233.png";